webpackJsonp([15],{

/***/ 2726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _signup_ldap = __webpack_require__(2727);

var _signup_ldap2 = _interopRequireDefault(_signup_ldap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    var isLicensed = license && license.IsLicensed === 'true';
    var ldapLoginFieldName = config.LdapLoginFieldName;
    var enableLdap = config.EnableLdap === 'true';
    var ldap = license.LDAP === 'true';
    var siteName = config.SiteName;
    var termsOfServiceLink = config.TermsOfServiceLink;
    var privacyPolicyLink = config.PrivacyPolicyLink;
    var customDescriptionText = config.CustomDescriptionText;

    return {
        isLicensed: isLicensed,
        ldapLoginFieldName: ldapLoginFieldName,
        enableLdap: enableLdap,
        ldap: ldap,
        siteName: siteName,
        termsOfServiceLink: termsOfServiceLink,
        privacyPolicyLink: privacyPolicyLink,
        customDescriptionText: customDescriptionText
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_signup_ldap2.default);

/***/ }),

/***/ 2727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _diagnostics_actions = __webpack_require__(804);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _team_actions = __webpack_require__(832);

var _user_actions = __webpack_require__(781);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _browser_history = __webpack_require__(273);

var _logo = __webpack_require__(851);

var _logo2 = _interopRequireDefault(_logo);

var _back_button = __webpack_require__(852);

var _back_button2 = _interopRequireDefault(_back_button);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _site_name_and_description = __webpack_require__(941);

var _site_name_and_description2 = _interopRequireDefault(_site_name_and_description);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SignupLdap = function (_React$Component) {
    (0, _inherits3.default)(SignupLdap, _React$Component);
    (0, _createClass3.default)(SignupLdap, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                location: _propTypes2.default.object,
                isLicensed: _propTypes2.default.bool.isRequired,
                ldapLoginFieldName: _propTypes2.default.string,
                enableLdap: _propTypes2.default.bool.isRequired,
                ldap: _propTypes2.default.bool.isRequired,
                siteName: _propTypes2.default.string,
                termsOfServiceLink: _propTypes2.default.string,
                privacyPolicyLink: _propTypes2.default.string,
                customDescriptionText: _propTypes2.default.string.isRequired
            };
        }
    }]);

    function SignupLdap(props) {
        (0, _classCallCheck3.default)(this, SignupLdap);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignupLdap.__proto__ || (0, _getPrototypeOf2.default)(SignupLdap)).call(this, props));

        _this.handleLdapSignup = _this.handleLdapSignup.bind(_this);
        _this.handleLdapSignupSuccess = _this.handleLdapSignupSuccess.bind(_this);

        _this.handleLdapIdChange = _this.handleLdapIdChange.bind(_this);
        _this.handleLdapPasswordChange = _this.handleLdapPasswordChange.bind(_this);

        _this.state = {
            ldapError: '',
            ldapId: '',
            ldapPassword: ''
        };
        return _this;
    }

    (0, _createClass3.default)(SignupLdap, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _diagnostics_actions.trackEvent)('signup', 'signup_user_01_welcome');
        }
    }, {
        key: 'handleLdapIdChange',
        value: function handleLdapIdChange(e) {
            this.setState({
                ldapId: e.target.value
            });
        }
    }, {
        key: 'handleLdapPasswordChange',
        value: function handleLdapPasswordChange(e) {
            this.setState({
                ldapPassword: e.target.value
            });
        }
    }, {
        key: 'handleLdapSignup',
        value: function handleLdapSignup(e) {
            var _this2 = this;

            e.preventDefault();

            this.setState({ ldapError: '' });

            (0, _user_actions.webLoginByLdap)(this.state.ldapId, this.state.ldapPassword, null, this.handleLdapSignupSuccess, function (err) {
                _this2.setState({
                    ldapError: err.message
                });
            });
        }
    }, {
        key: 'handleLdapSignupSuccess',
        value: function handleLdapSignupSuccess() {
            var _this3 = this;

            var hash = new URLSearchParams(this.props.location.search).get('h');
            var data = new URLSearchParams(this.props.location.search).get('d');
            var inviteId = new URLSearchParams(this.props.location.search).get('id');

            if (inviteId || hash) {
                (0, _team_actions.addUserToTeamFromInvite)(data, hash, inviteId, function () {
                    _this3.finishSignup();
                }, function () {
                    // there's not really a good way to deal with this, so just let the user log in like normal
                    _this3.finishSignup();
                });
            } else {
                this.finishSignup();
            }
        }
    }, {
        key: 'finishSignup',
        value: function finishSignup() {
            var _this4 = this;

            (0, _user_actions.loadMe)().then(function () {
                var redirectTo = new URLSearchParams(_this4.props.location.search).get('redirect_to');
                GlobalActions.loadDefaultLocale();
                if (redirectTo) {
                    _browser_history.browserHistory.push(redirectTo);
                } else {
                    GlobalActions.redirectUserToDefaultTeam();
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                customDescriptionText = _props.customDescriptionText,
                isLicensed = _props.isLicensed,
                siteName = _props.siteName;


            var ldapIdPlaceholder = void 0;
            if (this.props.ldapLoginFieldName) {
                ldapIdPlaceholder = this.props.ldapLoginFieldName;
            } else {
                ldapIdPlaceholder = Utils.localizeMessage('login.ldapUsername', 'AD/LDAP Username');
            }

            var errorClass = '';
            if (this.state.ldapError) {
                errorClass += ' has-error';
            }

            var ldapSignup = void 0;
            if (this.props.enableLdap && this.props.isLicensed && this.props.ldap) {
                ldapSignup = _react2.default.createElement(
                    'div',
                    { className: 'inner__content' },
                    _react2.default.createElement(
                        'h5',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup.ldap',
                                defaultMessage: 'AD/LDAP Credentials'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'form',
                        {
                            onSubmit: this.handleLdapSignup
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'signup__email-container' },
                            _react2.default.createElement(_form_error2.default, {
                                error: this.state.ldapError,
                                margin: true
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' + errorClass },
                                _react2.default.createElement('input', {
                                    className: 'form-control',
                                    name: 'ldapId',
                                    value: this.state.ldapId,
                                    placeholder: ldapIdPlaceholder,
                                    onChange: this.handleLdapIdChange,
                                    spellCheck: 'false',
                                    autoCapitalize: 'off'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' + errorClass },
                                _react2.default.createElement('input', {
                                    type: 'password',
                                    className: 'form-control',
                                    name: 'password',
                                    value: this.state.ldapPassword,
                                    placeholder: Utils.localizeMessage('login.password', 'Password'),
                                    onChange: this.handleLdapPasswordChange,
                                    spellCheck: 'false'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        type: 'submit',
                                        className: 'btn btn-primary',
                                        disabled: !this.state.ldapId || !this.state.ldapPassword
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'login.signIn',
                                        defaultMessage: 'Sign in'
                                    })
                                )
                            )
                        )
                    )
                );
            } else {
                return null;
            }

            var terms = null;
            if (ldapSignup) {
                terms = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'create_team.agreement',
                        defaultMessage: 'By proceeding to create your account and use {siteName}, you agree to our <a href=\'{TermsOfServiceLink}\'>Terms of Service</a> and <a href=\'{PrivacyPolicyLink}\'>Privacy Policy</a>. If you do not agree, you cannot use {siteName}.',
                        values: {
                            siteName: this.props.siteName,
                            TermsOfServiceLink: this.props.termsOfServiceLink,
                            PrivacyPolicyLink: this.props.privacyPolicyLink
                        }
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_back_button2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup-team__container padding--less' },
                        _react2.default.createElement('img', {
                            className: 'signup-team-logo',
                            src: _logo2.default
                        }),
                        _react2.default.createElement(_site_name_and_description2.default, {
                            customDescriptionText: customDescriptionText,
                            isLicensed: isLicensed,
                            siteName: siteName
                        }),
                        _react2.default.createElement(
                            'h4',
                            { className: 'color--light' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup_user_completed.lets',
                                defaultMessage: 'Let\'s create your account'
                            })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'color--light' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'signup_user_completed.haveAccount',
                                defaultMessage: 'Already have an account?'
                            }),
                            ' ',
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    to: {
                                        pathname: '/login',
                                        search: this.props.location.search
                                    }
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'signup_user_completed.signIn',
                                    defaultMessage: 'Click here to sign in.'
                                })
                            )
                        ),
                        ldapSignup,
                        terms
                    )
                )
            );
        }
    }]);
    return SignupLdap;
}(_react2.default.Component);

exports.default = SignupLdap;

/***/ })

});


// WEBPACK FOOTER //
// 15.350b924cd25619b512bf.js